import algoliarecommend from "@algolia/recommend";
import sortBy from "lodash.sortby";
import { runQuery } from "queries";
import { useEffect, useState } from "react";

const recommendClient = algoliarecommend(
  process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
  process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY,
);

const indexName = "cocktailclub-cocktails-en";

export const useRelatedCocktails = (objectID, maxRecommendations = 16) => {
  const [related, setRelated] = useState();
  const [loading, setIsLoading] = useState(false);
  useEffect(() => {
    async function fetchData() {
      const {
        results: [{ hits }],
      } = await recommendClient.getRelatedProducts([
        { objectID: `${objectID}`, indexName, maxRecommendations },
      ]);

      setRelated(hits);
      return;
      if (hits.length > 0) {
        const ids = hits.map((h) => h.objectID);
        const {
          props: { cocktails },
        } = await runQuery("cocktails/multiple", {
          filter: `{id: {_in: [${ids.join(",")}]}}`,
          limit: maxRecommendations,
        });
        setRelated(sortBy(cocktails, (c) => ids.indexOf(c.id.toString())));
      }
      setIsLoading(false);
    }
    if (!loading && objectID) {
      setIsLoading(true);
      fetchData();
    }
  }, [objectID]);

  return {
    related: related || [],
    loading: false,
  };
};
